<template>
    <div class="quality-ex-section">
        <div class="container">
            <h2>{{ qualityPage.skills_title }}</h2>
            <div class="desc-ex" v-html="qualityPage.skills_desc"></div>
        </div>
        <div class="quality-ex-img" :style="'background-image: url(' + qualityPage.skills_img + ')'"></div>
        <div class="desc-red" v-html="qualityPage.skills_desc_red"></div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'quality-ex-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            qualityPage: 'loadQualityPage',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/quality/quality-ex.scss';
    @import '@/styles/components/quality/respond/respond-quality-ex.scss';
    // @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>